"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrcadPowerPortLocalGlobalMergeRule = void 0;
const NetNamingRules_1 = require("../../../../NetCombobulation/NetNamingRules");
class OrcadPowerPortLocalGlobalMergeRule {
    constructor() {
        this.type = NetNamingRules_1.NetNamingRuleType.Group;
    }
    apply(manager, _hierarchy) {
        const portGroups = new Map();
        for (const group of manager.iterateGroups()) {
            for (const [instance, nets] of group.getNets()) {
                const scope = this.subdesignScope(instance);
                for (const net of nets) {
                    for (const label of net.labels) {
                        if (label.labelType !== 'hierarchical-port') {
                            continue;
                        }
                        const name = (label.formattedLabel ?? label.originalLabel).toUpperCase();
                        const key = this.bucketKey(scope, name);
                        const groups = portGroups.get(key) ?? new Set();
                        groups.add(group);
                        portGroups.set(key, groups);
                    }
                }
            }
        }
        if (portGroups.size === 0) {
            return manager;
        }
        const mergeBuckets = new Map();
        for (const group of manager.iterateGroups()) {
            for (const [instance, nets] of group.getNets()) {
                const scope = this.subdesignScope(instance);
                for (const net of nets) {
                    for (const label of net.labels) {
                        if (label.labelType !== 'global') {
                            continue;
                        }
                        const name = (label.formattedLabel ?? label.originalLabel).toUpperCase();
                        const key = this.bucketKey(scope, name);
                        const matchingPortGroups = portGroups.get(key);
                        if (!matchingPortGroups) {
                            continue;
                        }
                        let bucket = mergeBuckets.get(key);
                        if (!bucket) {
                            bucket = new Set();
                            for (const portGroup of matchingPortGroups) {
                                bucket.add(portGroup);
                            }
                            mergeBuckets.set(key, bucket);
                        }
                        bucket.add(group);
                    }
                    for (const conn of net.connections) {
                        const applies = conn.connection.appliesNetName;
                        if (!applies || applies.labelType !== 'global') {
                            continue;
                        }
                        const name = applies.label.toUpperCase();
                        const key = this.bucketKey(scope, name);
                        const matchingPortGroups = portGroups.get(key);
                        if (!matchingPortGroups) {
                            continue;
                        }
                        let bucket = mergeBuckets.get(key);
                        if (!bucket) {
                            bucket = new Set();
                            for (const portGroup of matchingPortGroups) {
                                bucket.add(portGroup);
                            }
                            mergeBuckets.set(key, bucket);
                        }
                        bucket.add(group);
                    }
                }
            }
        }
        for (const groups of mergeBuckets.values()) {
            if (groups.size <= 1) {
                continue;
            }
            manager.mergeGroups(...Array.from(groups));
        }
        return manager;
    }
    subdesignScope(instance) {
        return instance.sheetSymbol ? instance.pathUniqueId : '__top__';
    }
    bucketKey(scope, name) {
        return `${scope}\0${name}`;
    }
}
exports.OrcadPowerPortLocalGlobalMergeRule = OrcadPowerPortLocalGlobalMergeRule;
//# sourceMappingURL=OrcadPowerPortLocalGlobalMergeRule.js.map